import React from "react";
import sharedStyles from "../styles/SharedStyles.module.css";
import caveThreeWays from "../assets/cave_three_ways.png";

const Room1 = ({ goToRoom2, goToRoom3, goToRoom4, goBack }) => {
  return (
    <div className={sharedStyles.centeredContainer}>
      <h1 className={sharedStyles.pageTitle}>Unnamed Chamber</h1>
      <p className={sharedStyles.pageDescription}>
        The walls here are uneven, carved by time and unseen forces.
      </p>

      <div className={sharedStyles.sceneContainer}>
        {/* Room Image */}
        <img
          src={caveThreeWays}
          alt="Cave Room"
          className={sharedStyles.sceneImage}
        />

        {/* Path Buttons */}
        <button
          className={sharedStyles.button}
          style={{ top: "50%", left: "18%", position: "absolute" }}
          onClick={goToRoom2}
        >
          Left
        </button>
        <button
          className={sharedStyles.button}
          style={{ top: "48%", left: "85%", position: "absolute" }}
          onClick={goToRoom4}
        >
          Right
        </button>
        <button
          className={sharedStyles.button}
          style={{ top: "50%", left: "50%", position: "absolute" }}
          onClick={goToRoom3}
        >
          Straight
        </button>
      </div>

      {/* Go Back Button */}
      <button className={sharedStyles.backButton} onClick={goBack}>
        ← Go Back
      </button>
    </div>
  );
};

export default Room1;